import { Game } from "../../Game";

export class WorldObject {
    private _modelAssetKey: string;
    private _castShadows: boolean;
    private _receiveShadows: boolean;
    private _batchGroupId: number;
    private _lightmapped: boolean;
    private _static: boolean;

    private _cloneTempEntity: pc.Entity;

    //-------------------------------------------------------------------------
    /**
     * Konstruktor
     * @param modelAssetKey Jmeno assetu s modelem
     * @param castShadows True, pokud ma model vrhat stin
     * @param batchGroupId Index batch skupiny nebo undefined
     * @param lightmapped True, pokud se ma pro model zapect svetlo
     * @param stat True, pokud se jedna o staticky model
     * @param receiveShadows True, pokud model prijima stiny
     */
    //-------------------------------------------------------------------------
    constructor(modelAssetKey: string, castShadows: boolean, batchGroupId?: number, lightmapped: boolean = true, stat: boolean = true, receiveShadows: boolean = true) {
        this._modelAssetKey = modelAssetKey;
        this._castShadows = castShadows;
        this._batchGroupId = batchGroupId;
        this._lightmapped = lightmapped;
        this._static = stat;
        this._receiveShadows = receiveShadows;
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvoreni nove entity pro herni objekt
     */
    //-------------------------------------------------------------------------
    createEntity(): pc.Entity {
        if (!this._cloneTempEntity) {
            let e = new pc.Entity(this._modelAssetKey);

            e.addComponent(pc.eCompomentType.model, {
                type: pc.eModelType.asset,
                asset: Game.APP.assets.find(this._modelAssetKey, pc.eAssetType.model),
                castShadows: false,
                castShadowsLightmap: this._castShadows,
                receiveShadows: this._receiveShadows,
                lightmapped: this._lightmapped,
                static: this._static,
            });

            // Batchgroup        
            if (this._batchGroupId != undefined)
                e.model.batchGroupId = this._batchGroupId;

            this._cloneTempEntity = e;

            return e;
        }
        else {
            return this._cloneTempEntity.clone();
        }
    }
}